import React from 'react'

import { useEffect, useRef } from 'react'

import request from '@function/ajax/request'

export default function PickerPickedFetcher ({ onError, onResults, onPicked, ...props })
{
	const ref = useRef();

	useEffect(function ()
	{
		const controller = new AbortController();

		if (!props.picked || !ref) return;

		if (props.picked === ref.current) return;

		ref.current = props.picked;

		(async function ()
		{
			try
			{
				var response = await request(props.url)
				.config({ controller, keyword: 'action', min_req_time: 0 })
				.post({ model: props.model, id: props.picked });
			}
			catch (update)
			{
				if (controller?.signal?.aborted)
				{
					ref.current = undefined;
					return;
				}

				return onError
				? onError({ error: update.error })
				: console.error(update);
			}

			const options = response?.data || [];

			onResults(options);

			onPicked(null, options[0], options[0]?.data);
		})();

		return () => { controller?.abort?.(); };
	},
	[ref, props.picked, props.model, onError, onPicked, onResults, props.url]);

	return null;
}